import vi from '../../resources/locales/vi-VN.json';
export default {
  ...vi,
  ...JSON.parse(localStorage.getItem('overrides_translations') || '{}')['vi-VN'],
};
